'use client';

import { usePathname } from 'next/navigation';

import Footer from '@/components/footer';
import { Header } from '@/components/public-header';
import { PublicSidebar } from '@/components/public-sidebar';
import { SidebarProvider } from '@/components/ui/sidebar';

export function PublicLayoutShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isStatusRoute = pathname.startsWith('/status');

  return (
    <>
      <SidebarProvider defaultOpen={false}>
        <PublicSidebar />
        <section className="flex flex-1 flex-col overflow-auto">
          <Header />
          <main className="gap-6 pt-20">{children}</main>
        </section>
      </SidebarProvider>
      {!isStatusRoute && <Footer />}
    </>
  );
}
